// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZwsR9","col":"styles_col__3jd9H"};